module.exports = __webpack_public_path__ + "static/media/flowlin-2.4060aee1.jpg";